export default __webpack_public_path__ + "5d8dc9b1602f9118215d44bba80a31a5.png";